import { WINDOW, REPLAY_SESSION_KEY } from '../constants.js';

function saveSession(session) {
  var hasSessionStorage = ('sessionStorage' in WINDOW);

  if (!hasSessionStorage) {
    return;
  }

  try {
    WINDOW.sessionStorage.setItem(REPLAY_SESSION_KEY, JSON.stringify(session));
  } catch (e) {// Ignore potential SecurityError exceptions
  }
}

export { saveSession };